import { MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useProductKinds } from "../../../services/productsService";

const disabledInputSx = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#010a1a",
    },
};

export const ProductKindDropdown = (props) => {
    const { control, fieldName, disabled = false } = props;
    const { t } = useTranslation();

    const { data } = useProductKinds();
    const kinds = data?.results || [];

    if (kinds.length === 0) {
        return null;
    }

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
                <TextField
                    {...field}
                    select
                    fullWidth
                    disabled={disabled}
                    sx={{
                        ...props.textFieldSx,
                        ...(disabled ? disabledInputSx : {}),
                    }}
                >
                    {kinds.map((kind) => (
                        <MenuItem key={kind.id} value={kind.id}>
                            {t(`products.kind.${kind.key}`)}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
